<template>
    <div class="layout-footer">
        <span class="font-medium ml-2">{{ new Date().getFullYear() + ' ' + (setting.app_name || 'Umkm Management') + '. All Rights Reserved.' }}</span>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: mapState([
        'setting'
    ]),
}
</script>

<style lang="scss" scoped></style>
